<style lang="less">
@import url('app.less');
</style>
<template>
  <!-- v-title="title" -->
  <div id="app">
    <router-view />
  </div>
</template>

<script>

import config from './config'

export default {
  name: 'App',
  data() {
    return {
      title: config.title
    }
  }
}

</script>
